module.exports = __webpack_public_path__ + "img/bg-768@2x.cf3a2ddb.jpg";